<template>
  <div class="information">
    <b-jumbotron style="margin:auto;width:50%" container-fluid bg-variant="light">
    <div v-if="lang == 'en'">
      <p><strong>Dear Participant!&nbsp;</strong></p>
      <p>In this study you will hear short sounds. Your task will be to mark for every sound how close would you come or far would you go from something that emits that sound.<br />At the beginning, there will be four examples to make everything clear.</p>
      <p>Only people over the age of 18 can participate in the study.  </p>
      <p><strong>Please use headphones during the test!</strong><br /><strong>Please fill in the questionnaire using a PC or laptop, as it is not optimised for mobile phones. Tested on Chrome and Firefox. Use the latest version.</strong></p>
      <p><br />You will hear every sound once. Don't think too long; decide as fast as you can!</p>
      <p><br />The survey takes approximately 10 minutes.</p>
      <p><br />Participating is voluntary, you can stop filling out the questionnaire at any point. All data is handled confidentially. The questionnaire is anonymized and the data is stored in a separate, password protected database which can only be accessed by the researchers involved in the study. Personal data is not provided for any third party, and all data is only used for research purposes.  If you have further questions about the questionnaire or the study, you can email us at <span class="codedirection">moc.liamg@silavin.aletsum</span>. </p>
        <b-button @click="playSound(require('../assets/cow.wav'))" style="outline: none !important;   box-shadow: none;">Test sound</b-button>

    </div>
    <div v-if="lang == 'hu'">
      <p><strong>Kedves R&eacute;sztvevő!</strong></p>
      <p>Ebben a vizsg&aacute;latban r&ouml;vid hangokat fogsz hallani. A feladatod annyi, hogy minden hangn&aacute;l jel&ouml;ld be, mennyire menn&eacute;l k&ouml;zel vagy t&aacute;volodn&aacute;l el valamitől, ami ezt a hangot adja ki.<br /> A teszt legelej&eacute;n lesz p&aacute;r p&eacute;lda, hogy biztos minden vil&aacute;gos legyen.</p>
      <p>A kutatásban csak 18. életévüket betöltött személyek vehetnek részt.   </p>
      <p><br /> <strong>A teszt sor&aacute;n k&eacute;rj&uuml;k, haszn&aacute;lj f&uuml;lhallgat&oacute;t!</strong><br /><strong> A k&eacute;rdő&iacute;vet k&eacute;rj&uuml;k sz&aacute;m&iacute;t&oacute;g&eacute;pen t&ouml;ltsd ki, ne mobilon. Chromeon és Firefoxon tesztelve. Használd a legfrissebb verziót.</strong></p>
      <p><br /> Minden hangot csak egyszer fogsz hallani. Ne gondolkodj sokat a hangokon, d&ouml;nts, amilyen gyorsan tudsz!</p>
      <p><br /> A vizsg&aacute;lat hossza kb. 10 perc.</p>
      <p><br /> A kérdőívben való részvétel önkéntesen történik, a kitöltést bármikor megszakíthatod. Természetesen minden adatot bizalmasan kezelünk, a kérdőíveket anonimizáljuk és a kapott adatokat jelszóval védetten egy elkülönített adatbázisban tároljuk, melyhez csak a  vizsgálatot végző kutatók férhetnek hozzá. Személyes adatokat nem adunk ki harmadik félnek, és minden adatot kizárólag kutatási célra használunk fel. Ha további kérdésed van a kérdőívvel vagy a kutatással kapcsolatban, várjuk leveledet a <span class="codedirection">moc.liamg@silavin.aletsum</span> címen. </p>

      <b-button @click="playSound(require('../assets/cow.wav'))" style="outline: none !important;   box-shadow: none;">Hangpróba</b-button>
    </div>
    </b-jumbotron>

    <b-jumbotron style="margin:auto;width:50%" container-fluid bg-variant="light">

      <b-form @submit="onSubmit" @reset="onReset">
            <b-form-group id="namegroup"
                          :label="lang == 'en'? 'Name (optional)': 'Név (opcionális)'"
                          label-for="name"
                          description="">
              <b-form-input id="name"
                            type="text"
                            v-model="form.name"
                            :placeholder="lang == 'en'? 'Enter your name': 'Írja be a nevét'">
              </b-form-input>
            </b-form-group>

            <b-form-group id="sexgroup"
                          :label="lang == 'en'? 'Sex': 'Nem'"
                          label-for="sex"
                          description="">
              <b-form-select id="sex"
                            v-model="form.sex"
                            required
                            :options="sexoptions">
              </b-form-select>
            </b-form-group>

            <b-form-group id="birthdaygroup"
                          :label="lang == 'en'? 'Birthday': 'Születési idő'"
                          label-for="birthday"
                          description="">
              <b-form-input id="birthday"
                            type="date"
                            v-model="form.birthday"
                            required
                            >
              </b-form-input>
            </b-form-group>

            <b-form-group id="countrygroup"
                          :label="lang == 'en'? 'Country': 'Ország (Magyarország mint Hungary szerepel)'"
                          label-for="country"
                          description="">
              <b-form-select id="country"
                            v-model="form.country"
                            required
                            >
                            <option v-for="country in countries" :value="country.name">{{ country.name }}</option>
              </b-form-select>

            </b-form-group>
            <!-- <b-form-group label={{lang == 'en'? 'You need to agree to all' : 'Elolvastam a fenti tájékoztatót.' }}> -->


             <p>
              <b-form-checkbox
                required

              >
              {{lang == 'en'? 'I have read the above information.' : 'Elolvastam a fenti tájékoztatót.' }}
              </b-form-checkbox>
            </p>
            <p>
              <b-form-checkbox
                required
              >
              {{lang == 'en'? 'I declare that I participate in the research voluntarily.' : 'Kijelentem hogy önkéntesen veszek részt a vizsgálatban.' }}
              </b-form-checkbox>
            </p>
            <p>
              <b-form-checkbox
                required
              >
              {{lang == 'en'? 'I consent for my questionanire data to be used for research purposes as part of an anonimous database.' : 'Tudomásul veszem és hozzájárulok hogy az adataim anonim módon, az adatbázis részeként, a kutatás keretében felhasználásra kerüljenek.' }}
              </b-form-checkbox>
            </p>


              <b-button type="submit" variant="primary">{{lang == 'en'? 'Record data': 'Adatok rögzítése'}}</b-button>

            <b-button type="reset" variant="secondary">{{lang == 'en'? 'Reset': 'Törlés'}}</b-button>
          </b-form>
          <router-link :to="{ name: 'Test' }">
            <b-button type="secondary" style="margin-top:25px" v-if="cangonext">{{lang == 'en'? 'Next': 'Tovább'}}</b-button>
          </router-link>
    </b-jumbotron>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
const { detect } = require('detect-browser');

export default {
  name: 'information',
  computed: mapState([
    'lang',
    'countries',
    '_id'
  ]),
  data () {
    return {
      form: {
        sex: '',
        name: '',
        birthday: ''
      },
      sexoptions: [
        {value: 'male', text: (this.lang == 'en' ? 'male' : 'férfi')},
        {value: 'female', text: (this.lang == 'en' ? 'female' : 'nő')}
      ],
      cangonext: false
    }

  },
  methods: {
    ...mapMutations(['setId']),
    onSubmit (evt) {
      evt.preventDefault()
      this.form['lang'] = this.lang
      const browser = detect();
      if (browser) {
        this.form['browser_name']  = browser.name ;
        this.form['browser_version']  = browser.version;
        this.form['browser_os']  = browser.os;
      }
      this.$http.post('/api/new_measurement',this.form).then(
        res => {
          if (res.body.status == 'ok'){
            this.setId(res.body._id)
            console.log("id",this._id)
          }
        },
        res => {console.log('err')}
      )
      this.cangonext = true
    },
    onReset (evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.form.email = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
      /* Trick to reset/clear native browser form validation state */
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    playSound (sound) {
      if (sound) {
        var audio = new Audio(sound)
        audio.play()
      }
    }

  },
  mounted () {
    console.log(this.lang)
    this.sexoptions = [
      {value: 'male', text: (this.lang == 'en' ? 'male' : 'férfi')},
      {value: 'female', text: (this.lang == 'en' ? 'female' : 'nő')}
    ]
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/Information.vue